import { GuardianSimple } from '@dreryk/egabinet-patient-frontend-api';
import { GuardianExternalIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { EditIcon, Link, StyledFlex } from '@dreryk/react-components';

import { GuardianMarkAsRemovedParameters } from '../../GuardiansTable.hooks';

import { GuardianDeleteIcon } from './GuardianDeleteIcon';

type ActionsCellProps = {
   readonly onEdit: (guardianId: number, guardianIdentifier: GuardianExternalIdentifier) => void;
   readonly onDelete: (variables: GuardianMarkAsRemovedParameters) => void;
   readonly guardian: GuardianSimple;
};

export const ActionsCell = (props: ActionsCellProps): JSX.Element => (
   <StyledFlex justifyContent={'flex-end'} flex={'1'}>
      <Link
         onClick={() => props.onEdit(props.guardian.id, props.guardian.guardianExternalIdentifier)}
         icon={<EditIcon />}
         testId={'update'}
      />
      <GuardianDeleteIcon guardian={props.guardian} onDelete={props.onDelete} />
   </StyledFlex>
);
